import { An as vtkCellArray$1, Ar as vtkMath, Cr as degreesFromRadians, Er as norm, Jn as create$1, Mr as macro, Or as radiansFromDegrees, Sn as vtkTriangle$1, X as BinaryHelper, Xn as normalize, Y as DataAccessHelper, Yn as getAxisAngle, Zn as slerp, _n as vtkTransform$1, _r as multiply, bn as vtkPolyData$1, c as vtkTexture$1, dn as vtkLight$1, dr as transformMat4, er as create, fn as vtkCamera$1, fr as clone, ir as fromValues, jn as vtkBoundingBox, kn as vtkPoints$1, kr as subtract, ln as vtkActor$1, mr as fromRotationTranslationScale, or as lerp, pn as vtkMapper$1, pr as create$2, q as vtkPolyDataNormals$1, wn as AttributeTypes, xr as vtkDataArray$1 } from "./cornerstone-core-CholjC0D.js";
var { vtkWarningMacro: vtkWarningMacro$5 } = macro;
function vtkLineSource(e, l) {
  l.classHierarchy.push("vtkLineSource"), e.requestData = (e2, u) => {
    let f = u[0], m = f ? f.getPoints().getDataType() : l.pointType, h = f?.initialize() || vtkPolyData$1.newInstance(), g = [];
    if (subtract(l.point2, l.point1, g), norm(g) <= 0) {
      vtkWarningMacro$5("Zero-length line definition");
      return;
    }
    let _ = l.resolution, v = _ + 1, y = macro.newTypedArray(m, v * 3);
    h.getPoints().setData(y, 3);
    let b = new Uint32Array(v + 1);
    h.getLines().setData(b, 1);
    let x = 0, S = 0;
    for (let e3 = 0; e3 < _ + 1; e3++)
      S = e3 / _, y[x * 3] = l.point1[0] + S * g[0], y[x * 3 + 1] = l.point1[1] + S * g[1], y[x * 3 + 2] = l.point1[2] + S * g[2], x++;
    x = 0, b[0] = v;
    for (let e3 = 0; e3 < v; e3++)
      b[e3 + 1] = e3;
    u[0] = h;
  };
}
var DEFAULT_VALUES$5 = {
  resolution: 10,
  point1: [
    -1,
    0,
    0
  ],
  point2: [
    1,
    0,
    0
  ],
  pointType: "Float64Array"
};
function extend$5(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES$5, u), macro.obj(e, l), macro.setGet(e, l, ["resolution"]), macro.setGetArray(e, l, ["point1", "point2"], 3), macro.algo(e, l, 0, 1), vtkLineSource(e, l);
}
var vtkLineSource$1 = {
  newInstance: macro.newInstance(extend$5, "vtkLineSource"),
  extend: extend$5
}, FormatTypes = {
  ASCII: "ascii",
  BINARY: "binary"
}, { vtkErrorMacro: vtkErrorMacro$3 } = macro;
function writeFloatBinary(e, l, u) {
  return e.setFloat32(l, u.toPrecision(6), true), l + 4;
}
function writeVectorBinary(e, l, u) {
  let d = writeFloatBinary(e, l, u[0]);
  return d = writeFloatBinary(e, d, u[1]), writeFloatBinary(e, d, u[2]);
}
var binaryWriter = () => {
  let e = 0, l = null;
  return {
    init: (e2) => {
      let u = e2.getPolys().getData(), d = /* @__PURE__ */ new ArrayBuffer(84 + 50 * u.length / 4);
      l = new DataView(d);
    },
    writeHeader: (u) => {
      e += 80, l.setUint32(e, u.getNumberOfCells(), true), e += 4;
    },
    writeTriangle: (u, d, f, p) => {
      e = writeVectorBinary(l, e, p), e = writeVectorBinary(l, e, u), e = writeVectorBinary(l, e, d), e = writeVectorBinary(l, e, f), e += 2;
    },
    writeFooter: (e2) => {
    },
    getOutputData: () => l
  };
}, asciiWriter = () => {
  let e = "";
  return {
    init: (e2) => {
    },
    writeHeader: (l) => {
      e += "solid ascii\n";
    },
    writeTriangle: (l, u, d, f) => {
      e += ` facet normal ${f[0].toPrecision(6)} ${f[1].toPrecision(6)} ${f[2].toPrecision(6)}
`, e += "  outer loop\n", e += `   vertex ${l[0].toPrecision(6)} ${l[1].toPrecision(6)} ${l[2].toPrecision(6)}
`, e += `   vertex ${u[0].toPrecision(6)} ${u[1].toPrecision(6)} ${u[2].toPrecision(6)}
`, e += `   vertex ${d[0].toPrecision(6)} ${d[1].toPrecision(6)} ${d[2].toPrecision(6)}
`, e += "  endloop\n", e += " endfacet\n";
    },
    writeFooter: (l) => {
      e += "endsolid\n";
    },
    getOutputData: () => e
  };
};
function writeSTL(e) {
  let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FormatTypes.BINARY, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, d = null;
  l === FormatTypes.BINARY ? d = binaryWriter() : l === FormatTypes.ASCII ? d = asciiWriter() : vtkErrorMacro$3("Invalid format type"), d.init(e), d.writeHeader(e);
  let f = e.getPolys().getData(), p = e.getPoints().getData(), m = e.getStrips() ? e.getStrips().getData() : null, g = [], _ = [], v = [], y = [];
  if (m && m.length > 0)
    throw Error("Unsupported strips");
  for (let e2 = 0; e2 < f.length; )
    f[e2++] && (_ = [
      p[f[e2] * 3],
      p[f[e2] * 3 + 1],
      p[f[e2++] * 3 + 2]
    ], v = [
      p[f[e2] * 3],
      p[f[e2] * 3 + 1],
      p[f[e2++] * 3 + 2]
    ], y = [
      p[f[e2] * 3],
      p[f[e2] * 3 + 1],
      p[f[e2++] * 3 + 2]
    ], u && (transformMat4(_, _, u), transformMat4(v, v, u), transformMat4(y, y, u)), vtkTriangle$1.computeNormal(_, v, y, g), d.writeTriangle(_, v, y, g));
  return d.writeFooter(e), d.getOutputData();
}
var STATIC = { writeSTL };
function vtkSTLWriter(e, l) {
  l.classHierarchy.push("vtkSTLWriter"), e.requestData = (e2, u) => {
    let d = e2[0];
    if (!d || d.getClassName() !== "vtkPolyData") {
      vtkErrorMacro$3("Invalid or missing input");
      return;
    }
    u[0] = writeSTL(d, l.format, l.transform);
  };
}
var DEFAULT_VALUES$4 = {
  format: FormatTypes.BINARY,
  transform: null
};
function extend$4(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES$4, u), macro.obj(e, l), macro.algo(e, l, 1, 1), macro.setGet(e, l, ["format", "transform"]), vtkSTLWriter(e, l);
}
var vtkSTLWriter$1 = {
  newInstance: macro.newInstance(extend$4, "vtkSTLWriter"),
  extend: extend$4,
  ...STATIC
}, VertexType = {
  VTK_SIMPLE_VERTEX: 0,
  VTK_FIXED_VERTEX: 1,
  VTK_FEATURE_EDGE_VERTEX: 2,
  VTK_BOUNDARY_EDGE_VERTEX: 3
};
function vtkWindowedSincPolyDataFilter(e, u) {
  u.classHierarchy.push("vtkWindowedSincPolyDataFilter"), e.vtkWindowedSincPolyDataFilterExecute = (e2, d, f) => {
    if (!e2 || u.numberOfIterations <= 0)
      return e2;
    let m = e2.getData(), g = d.getVerts().getData(), _ = d.getLines().getData(), v = d.getPolys().getData(), y = d.getStrips().getData(), b = Math.cos(vtkMath.radiansFromDegrees(u.featureAngle)), x = Math.cos(vtkMath.radiansFromDegrees(u.edgeAngle)), S = e2.getNumberOfPoints(), w = Array(S);
    for (let e3 = 0; e3 < S; ++e3)
      w[e3] = {
        type: VertexType.VTK_SIMPLE_VERTEX,
        edges: null
      };
    let T = 0;
    for (let e3 = 0; e3 < g.length; e3 += T + 1) {
      T = g[e3];
      let l = g.slice(e3 + 1, e3 + 1 + T);
      for (let e4 = 0; e4 < l.length; ++e4)
        w[l[e4]].type = VertexType.VTK_FIXED_VERTEX;
    }
    for (let e3 = 0; e3 < _.length; e3 += T + 1) {
      T = _[e3];
      let l = _.slice(e3 + 1, e3 + 1 + T), u2 = l[0] === l[T - 1] && T > 3;
      for (let e4 = 0; e4 < T; ++e4)
        w[l[e4]].type === VertexType.VTK_SIMPLE_VERTEX ? e4 === 0 ? u2 ? (w[l[0]].type = VertexType.VTK_FEATURE_EDGE_VERTEX, w[l[0]].edges = [l[T - 2], l[1]]) : w[l[0]].type = VertexType.VTK_FIXED_VERTEX : e4 === T - 1 && !u2 ? w[l[e4]].type = VertexType.VTK_FIXED_VERTEX : (w[l[e4]].type = VertexType.VTK_FEATURE_EDGE_VERTEX, w[l[e4]].edges = [l[e4 - 1], l[u2 && e4 === T - 2 ? 0 : e4 + 1]]) : w[l[e4]].type === VertexType.VTK_FEATURE_EDGE_VERTEX && !(u2 && e4 === T - 1) && (w[l[e4]].type = VertexType.VTK_FIXED_VERTEX, w[l[e4]].edges = null);
    }
    let E = v.length, D = y.length;
    if (E > 0 || D > 0) {
      let f2 = vtkPolyData$1.newInstance();
      f2.setPoints(d.getPoints()), f2.setPolys(d.getPolys());
      let p = f2, m2 = [], g2 = 0, _2 = [], v2 = [];
      p.buildLinks();
      let y2 = p.getPolys().getData(), x2 = 0;
      for (let d2 = 0; d2 < y2.length; d2 += T + 1, ++x2) {
        T = y2[d2];
        let f3 = y2.slice(d2 + 1, d2 + 1 + T);
        for (let d3 = 0; d3 < T; ++d3) {
          let y3 = f3[d3], S2 = f3[(d3 + 1) % T];
          w[y3].edges === null && (w[y3].edges = []), w[S2].edges ?? (w[S2].edges = []), m2 = p.getCellEdgeNeighbors(x2, y3, S2);
          let C = m2.length, E2 = VertexType.VTK_SIMPLE_VERTEX;
          if (C === 0)
            E2 = VertexType.VTK_BOUNDARY_EDGE_VERTEX;
          else if (C >= 2) {
            if (!u.nonManifoldSmoothing) {
              let e3 = 0;
              for (; e3 < C && !(m2[e3] < x2); ++e3)
                ;
              e3 >= C && (E2 = VertexType.VTK_FEATURE_EDGE_VERTEX);
            }
          } else if (C === 1 && (g2 = m2[0]) > x2) {
            if (u.featureEdgeSmoothing) {
              vtkTriangle$1.computeNormal(e2.getPoint(f3[0]), e2.getPoint(f3[1]), e2.getPoint(f3[2]), _2);
              let { cellPointIds: u2 } = p.getCellPoints(g2);
              vtkTriangle$1.computeNormal(e2.getPoint(u2[0]), e2.getPoint(u2[1]), e2.getPoint(u2[2]), v2), vtkMath.dot(_2, v2) <= b && (E2 = VertexType.VTK_FEATURE_EDGE_VERTEX);
            }
          } else
            continue;
          E2 && w[y3].type === VertexType.VTK_SIMPLE_VERTEX ? (w[y3].edges = [S2], w[y3].type = E2) : (E2 && w[y3].type === VertexType.VTK_BOUNDARY_EDGE_VERTEX || E2 && w[y3].type === VertexType.VTK_FEATURE_EDGE_VERTEX || !E2 && w[y3].type === VertexType.VTK_SIMPLE_VERTEX) && (w[y3].edges.push(S2), w[y3].type && E2 === VertexType.VTK_BOUNDARY_EDGE_VERTEX && (w[y3].type = VertexType.VTK_BOUNDARY_EDGE_VERTEX)), E2 && w[S2].type === VertexType.VTK_SIMPLE_VERTEX ? (w[S2].edges = [y3], w[S2].type = E2) : (E2 && w[S2].type === VertexType.VTK_BOUNDARY_EDGE_VERTEX || E2 && w[S2].type === VertexType.VTK_FEATURE_EDGE_VERTEX || !E2 && w[S2].type === VertexType.VTK_SIMPLE_VERTEX) && (w[S2].edges.push(y3), w[S2].type && E2 === VertexType.VTK_BOUNDARY_EDGE_VERTEX && (w[S2].type = VertexType.VTK_BOUNDARY_EDGE_VERTEX));
        }
      }
    }
    for (let d2 = 0; d2 < S; ++d2)
      if (w[d2].type !== VertexType.VTK_SIMPLE_VERTEX && w[d2].type !== VertexType.VTK_FIXED_VERTEX && (w[d2].type === VertexType.VTK_FEATURE_EDGE_VERTEX || w[d2].type === VertexType.VTK_BOUNDARY_EDGE_VERTEX))
        if (!u.boundarySmoothing && w[d2].type === VertexType.VTK_BOUNDARY_EDGE_VERTEX)
          w[d2].type = VertexType.VTK_FIXED_VERTEX;
        else if ((T = w[d2].edges.length) !== 2)
          w[d2].type = VertexType.VTK_FIXED_VERTEX;
        else {
          let u2 = e2.getPoint(w[d2].edges[0]), f2 = e2.getPoint(d2), p = e2.getPoint(w[d2].edges[1]), m2 = [
            0,
            0,
            0
          ], h = [
            0,
            0,
            0
          ];
          for (let e3 = 0; e3 < 3; ++e3)
            m2[e3] = f2[e3] - u2[e3], h[e3] = p[e3] - f2[e3];
          vtkMath.normalize(m2) >= 0 && vtkMath.normalize(h) >= 0 && vtkMath.dot(m2, h) < x ? w[d2].type = VertexType.VTK_FIXED_VERTEX : (w[d2].type, VertexType.VTK_FEATURE_EDGE_VERTEX);
        }
    let O = 0, k = 1, A = 2, j = [];
    j.push(vtkPoints$1.newInstance()), j[O].setNumberOfPoints(S), j.push(vtkPoints$1.newInstance()), j[k].setNumberOfPoints(S), j.push(vtkPoints$1.newInstance()), j[A].setNumberOfPoints(S), j.push(vtkPoints$1.newInstance()), j[3].setNumberOfPoints(S);
    let M = vtkBoundingBox.getCenter(d.getBounds()), N = vtkBoundingBox.getDiagonalLength(d.getBounds());
    if (u.normalizeCoordinates) {
      let l = [
        0,
        0,
        0
      ];
      for (let u2 = 0; u2 < S; ++u2)
        e2.getPoint(u2, l), l[0] = (l[0] - M[0]) / N, l[1] = (l[1] - M[1]) / N, l[2] = (l[2] - M[2]) / N, j[O].setPoint(u2, ...l);
    } else {
      let e3 = macro.newTypedArray(j[O].getDataType(), m);
      j[O].setData(e3, 3);
    }
    let P = u.passBand, F = Math.acos(1 - 0.5 * P), I = Array(u.numberOfIterations + 1), L = Array(u.numberOfIterations + 1), R = Array(u.numberOfIterations + 1), z = [
      0,
      0,
      0
    ];
    for (let e3 = 0; e3 <= u.numberOfIterations; ++e3)
      I[e3] = 0.54 + 0.46 * Math.cos(e3 * Math.PI / (u.numberOfIterations + 1));
    let B = 0, V = 0, H = false, U = 0;
    for (let e3 = 0; !H && e3 < 500; ++e3) {
      L[0] = I[0] * (F + U) / Math.PI;
      for (let e4 = 1; e4 <= u.numberOfIterations; ++e4)
        L[e4] = 2 * I[e4] * Math.sin(e4 * (F + U)) / (e4 * Math.PI);
      R[u.numberOfIterations] = 0, R[u.numberOfIterations - 1] = 0, u.numberOfIterations > 1 && (R[u.numberOfIterations - 2] = 2 * (u.numberOfIterations - 1) * L[u.numberOfIterations - 1]);
      for (let e4 = u.numberOfIterations - 3; e4 >= 0; --e4)
        R[e4] = R[e4 + 2] + 2 * (e4 + 1) * L[e4 + 1];
      B = 0, V = 0, B += L[0], V += R[0];
      for (let e4 = 1; e4 <= u.numberOfIterations; ++e4)
        e4 === 1 ? (B += L[e4] * (1 - 0.5 * P), V += R[e4] * (1 - 0.5 * P)) : (B += L[e4] * Math.cos(e4 * Math.acos(1 - 0.5 * P)), V += R[e4] * Math.cos(e4 * Math.acos(1 - 0.5 * P)));
      u.numberOfIterations > 1 ? Math.abs(B - 1) >= 1e-3 ? U -= (B - 1) / V : H = true : (H = true, U = 0);
    }
    Math.abs(B - 1) >= 1e-3 && console.log("An optimal offset for the smoothing filter could not be found.  Unpredictable smoothing/shrinkage may result.");
    let W = [
      0,
      0,
      0
    ], G = [
      0,
      0,
      0
    ], K = [
      0,
      0,
      0
    ], q = [
      0,
      0,
      0
    ], J = [
      0,
      0,
      0
    ], Y = [
      0,
      0,
      0
    ];
    for (let e3 = 0; e3 < S; ++e3)
      if (w[e3].edges != null && (T = w[e3].edges.length) > 0) {
        j[O].getPoint(e3, W), K[0] = 0, K[1] = 0, K[2] = 0;
        for (let l = 0; l < T; ++l) {
          j[O].getPoint(w[e3].edges[l], G);
          for (let e4 = 0; e4 < 3; ++e4)
            K[e4] += (W[e4] - G[e4]) / T;
        }
        for (let e4 = 0; e4 < 3; ++e4)
          K[e4] = W[e4] - 0.5 * K[e4];
        if (j[k].setPoint(e3, ...K), w[e3].type === VertexType.VTK_FIXED_VERTEX)
          j[O].getPoint(e3, K);
        else
          for (let e4 = 0; e4 < 3; ++e4)
            K[e4] = L[0] * W[e4] + L[1] * K[e4];
        j[3].setPoint(e3, ...K);
      } else
        j[k].setPoint(e3, ...z), j[O].getPoint(e3, K), j[3].setPoint(e3, ...K);
    let X = [
      0,
      0,
      0
    ], Z = [
      0,
      0,
      0
    ], Q = [
      0,
      0,
      0
    ], $ = 2;
    for (; $ <= u.numberOfIterations; $++) {
      for (let e3 = 0; e3 < S; ++e3)
        if (T = w[e3].edges == null ? 0 : w[e3].edges.length, T > 0) {
          j[O].getPoint(e3, X), j[k].getPoint(e3, Z), K[0] = 0, K[1] = 0, K[2] = 0;
          for (let l = 0; l < T; ++l) {
            j[k].getPoint(w[e3].edges[l], G);
            for (let e4 = 0; e4 < 3; ++e4)
              K[e4] += (Z[e4] - G[e4]) / T;
          }
          for (let e4 = 0; e4 < 3; ++e4)
            K[e4] = Z[e4] - X[e4] + Z[e4] - K[e4];
          j[A].setPoint(e3, ...K), j[3].getPoint(e3, Q);
          for (let e4 = 0; e4 < 3; ++e4)
            q[e4] = Q[e4] + L[$] * K[e4];
          w[e3].type !== VertexType.VTK_FIXED_VERTEX && j[3].setPoint(e3, ...q);
        } else
          j[k].setPoint(e3, ...z), j[A].setPoint(e3, ...z);
      O = (1 + O) % 3, k = (1 + k) % 3, A = (1 + A) % 3;
    }
    if (--$, O = 3, u.normalizeCoordinates) {
      let e3 = [
        0,
        0,
        0
      ];
      for (let l = 0; l < S; ++l) {
        j[O].getPoint(l, e3);
        for (let l2 = 0; l2 < 3; ++l2)
          e3[l2] = e3[l2] * N + M[l2];
        j[O].setPoint(l, ...e3);
      }
    }
    if (u.generateErrorScalars) {
      let l = new Float32Array(S);
      for (let u3 = 0; u3 < S; ++u3)
        e2.getPoint(u3, J), j[O].getPoint(u3, Y), l[u3] = Math.sqrt(Math.distance2BetweenPoints(J, Y));
      let u2 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: l
      }), d2 = f.getPointData().addArray(u2);
      f.getPointData().setActiveAttribute(d2, AttributeTypes.SCALARS);
    }
    if (u.generateErrorVectors) {
      let l = new Float32Array(3 * S);
      for (let u3 = 0; u3 < S; ++u3) {
        e2.getPoint(u3, J), j[O].getPoint(u3, Y);
        for (let e3 = 0; e3 < 3; ++e3)
          l[3 * u3 + e3] = Y[e3] - J[e3];
      }
      let u2 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: l
      });
      f.getPointData().setVectors(u2);
    }
    return j[O];
  }, e.requestData = (l, u2) => {
    if (!e.getNumberOfInputPorts())
      return;
    let d = l[0];
    if (!d)
      return;
    let f = u2[0]?.initialize() || vtkPolyData$1.newInstance(), p = e.vtkWindowedSincPolyDataFilterExecute(d.getPoints(), d, f);
    f.setPointData(d.getPointData()), f.setCellData(d.getCellData()), f.setFieldData(d.getFieldData()), f.setPoints(p), f.setVerts(d.getVerts()), f.setLines(d.getLines()), f.setPolys(d.getPolys()), f.setStrips(d.getStrips()), u2[0] = f;
  };
}
var DEFAULT_VALUES$3 = {
  numberOfIterations: 20,
  passBand: 0.1,
  featureAngle: 45,
  edgeAngle: 15,
  featureEdgeSmoothing: 0,
  boundarySmoothing: 1,
  nonManifoldSmoothing: 0,
  generateErrorScalars: 0,
  generateErrorVectors: 0,
  normalizeCoordinates: 0
};
function extend$3(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES$3, u), macro.obj(e, l), macro.algo(e, l, 1, 1), macro.setGet(e, l, [
    "numberOfIterations",
    "passBand",
    "featureAngle",
    "edgeAngle",
    "featureEdgeSmoothing",
    "boundarySmoothing",
    "nonManifoldSmoothing",
    "generateErrorScalars",
    "generateErrorVectors",
    "normalizeCoordinates"
  ]), vtkWindowedSincPolyDataFilter(e, l);
}
var vtkWindowedSincPolyDataFilter$1 = {
  newInstance: macro.newInstance(extend$3, "vtkWindowedSincPolyDataFilter"),
  extend: extend$3
}, { vtkErrorMacro: vtkErrorMacro$2 } = macro, decoderModule = null;
function setWasmBinary(e, l) {
  let u = {};
  return new Promise((d, f) => {
    u.wasmBinaryFile = l;
    let p = new XMLHttpRequest();
    p.open("GET", e, true), p.responseType = "arraybuffer", p.onload = () => {
      p.status === 200 ? (u.wasmBinary = p.response, Promise.resolve(window.DracoDecoderModule(u)).then((e2) => {
        decoderModule = e2, d(true);
      }, f)) : f(Error(`WASM binary could not be loaded: ${p.statusText}`));
    }, p.send(null);
  });
}
async function setDracoDecoder(e) {
  decoderModule = await e({});
}
function getDracoDecoder() {
  return decoderModule;
}
function getDracoDataType(e) {
  switch (e) {
    case Float32Array:
      return decoderModule.DT_FLOAT32;
    case Int8Array:
      return decoderModule.DT_INT8;
    case Int16Array:
      return decoderModule.DT_INT16;
    case Int32Array:
      return decoderModule.DT_INT32;
    case Uint8Array:
      return decoderModule.DT_UINT8;
    case Uint16Array:
      return decoderModule.DT_UINT16;
    case Uint32Array:
      return decoderModule.DT_UINT32;
    default:
      return decoderModule.DT_FLOAT32;
  }
}
function decodeAttribute(e, l, u, d, f) {
  let p = f.num_components(), m = l.num_points() * p, h = m * d.BYTES_PER_ELEMENT, g = getDracoDataType(d), _ = decoderModule._malloc(h);
  e.GetAttributeDataArrayForAllPoints(l, f, g, h, _);
  let v = new d(decoderModule.HEAPF32.buffer, _, m).slice();
  return decoderModule._free(_), {
    name: u,
    array: v,
    itemSize: p
  };
}
function decodeIndices(e, l) {
  let u = l.num_faces() * 3, d = u * 4, f = decoderModule._malloc(d);
  e.GetTrianglesUInt32Array(l, d, f);
  let p = new Uint32Array(decoderModule.HEAPF32.buffer, f, u).slice();
  return decoderModule._free(f), p;
}
function getPolyDataFromDracoGeometry(l, u) {
  let d = decodeIndices(l, u), f = d.length - 2, p = vtkCellArray$1.newInstance();
  p.allocate(4 * d.length / 3);
  for (let e = 0; e < f; e += 3) {
    let l2 = d.slice(e, e + 3);
    p.insertNextCell(l2);
  }
  let m = vtkPolyData$1.newInstance({ polys: p }), h = {
    points: "POSITION",
    normals: "NORMAL",
    scalars: "COLOR",
    tcoords: "TEX_COORD"
  };
  if (Object.keys(h).forEach((e) => {
    let d2 = Float32Array, f2 = l.GetAttributeId(u, decoderModule[h[e]]);
    if (f2 === -1)
      return;
    let p2 = decodeAttribute(l, u, e, d2, l.GetAttribute(u, f2)), g = m.getPointData();
    switch (e) {
      case "points":
        m.getPoints().setData(p2.array, p2.itemSize);
        break;
      case "normals":
        g.setNormals(vtkDataArray$1.newInstance({
          numberOfComponents: p2.itemSize,
          values: p2.array,
          name: "Normals"
        }));
        break;
      case "scalars":
        g.setScalars(vtkDataArray$1.newInstance({
          numberOfComponents: p2.itemSize,
          values: p2.array,
          name: "Scalars"
        }));
        break;
      case "tcoords":
        g.setTCoords(vtkDataArray$1.newInstance({
          numberOfComponents: p2.itemSize,
          values: p2.array,
          name: "TCoords"
        }));
        break;
    }
  }), !m.getPointData().getNormals()) {
    let e = vtkPolyDataNormals$1.newInstance();
    return e.setInputData(m), e.setComputePointNormals(true), e.getOutputData();
  }
  return m;
}
function vtkDracoReader(e, l) {
  l.classHierarchy.push("vtkDracoReader"), l.dataAccessHelper ||= DataAccessHelper.get("http");
  function u(u2) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { compression: f, progressCallback: p } = l;
    return d.binary ? l.dataAccessHelper.fetchBinary(u2, {
      compression: f,
      progressCallback: p
    }) : l.dataAccessHelper.fetchText(e, u2, {
      compression: f,
      progressCallback: p
    });
  }
  e.setUrl = function(u2) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { binary: true };
    l.url = u2;
    let f = u2.split("/");
    return f.pop(), l.baseURL = f.join("/"), l.compression = d.compression, e.loadData({
      progressCallback: d.progressCallback,
      binary: !!d.binary
    });
  }, e.loadData = function() {
    let d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = u(l.url, d);
    return f.then(e.parse), f;
  }, e.parse = (l2) => {
    e.parseAsArrayBuffer(l2);
  }, e.parseAsArrayBuffer = (u2) => {
    if (!u2)
      return;
    if (u2 !== l.parseData)
      e.modified();
    else
      return;
    l.parseData = u2;
    let d = new Int8Array(u2), f = new decoderModule.Decoder(), p = new decoderModule.DecoderBuffer();
    p.Init(d, d.length);
    let m = f.GetEncodedGeometryType(p), h;
    if (m === decoderModule.TRIANGULAR_MESH) {
      h = new decoderModule.Mesh();
      let e2 = f.DecodeBufferToMesh(p, h);
      if (!e2.ok()) {
        vtkErrorMacro$2(`Could not decode Draco file: ${e2.error_msg()}`);
        return;
      }
    } else {
      vtkErrorMacro$2("Wrong geometry type, expected mesh, got point cloud.");
      return;
    }
    let g = getPolyDataFromDracoGeometry(f, h);
    decoderModule.destroy(h), decoderModule.destroy(p), decoderModule.destroy(f), l.output[0] = g;
  }, e.requestData = () => {
    e.parse(l.parseData);
  };
}
var DEFAULT_VALUES$2 = {};
function extend$2(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES$2, u), macro.obj(e, l), macro.get(e, l, ["url", "baseURL"]), macro.setGet(e, l, ["dataAccessHelper"]), macro.algo(e, l, 0, 1), vtkDracoReader(e, l), l.compression ||= null, l.progressCallback ||= null;
}
var vtkDracoReader$1 = {
  extend: extend$2,
  newInstance: macro.newInstance(extend$2, "vtkDracoReader"),
  setDracoDecoder,
  setWasmBinary,
  getDracoDecoder
}, BINARY_CHUNK_TYPES = {
  JSON: 1313821514,
  BIN: 5130562
}, MIN_LIGHT_ATTENUATION = 0.01, COMPONENTS = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, BYTES = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
}, MODES = {
  GL_POINTS: 0,
  GL_LINES: 1,
  GL_LINE_LOOP: 2,
  GL_LINE_STRIP: 3,
  GL_TRIANGLES: 4,
  GL_TRIANGLE_STRIP: 5,
  GL_TRIANGLE_FAN: 6
}, ARRAY_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, GL_SAMPLER = {
  NEAREST: 9728,
  LINEAR: 9729,
  NEAREST_MIPMAP_NEAREST: 9984,
  LINEAR_MIPMAP_NEAREST: 9985,
  NEAREST_MIPMAP_LINEAR: 9986,
  LINEAR_MIPMAP_LINEAR: 9987,
  REPEAT: 10497,
  CLAMP_TO_EDGE: 33071,
  MIRRORED_REPEAT: 33648,
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243
}, DEFAULT_SAMPLER = {
  magFilter: GL_SAMPLER.NEAREST,
  minFilter: GL_SAMPLER.LINEAR_MIPMAP_LINEAR,
  wrapS: GL_SAMPLER.REPEAT,
  wrapT: GL_SAMPLER.REPEAT
}, SEMANTIC_ATTRIBUTE_MAP = {
  NORMAL: "normal",
  POSITION: "position",
  TEXCOORD_0: "texcoord0",
  TEXCOORD_1: "texcoord1",
  WEIGHTS_0: "weight",
  JOINTS_0: "joint",
  COLOR_0: "color",
  TANGENT: "tangent"
}, ALPHA_MODE = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
}, { vtkWarningMacro: vtkWarningMacro$4, vtkErrorMacro: vtkErrorMacro$1 } = macro;
function getGLEnumFromSamplerParameter(e) {
  return {
    magFilter: 10240,
    minFilter: 10241,
    wrapS: 10242,
    wrapT: 10243
  }[e];
}
function getAccessorArrayTypeAndLength(e, l) {
  let u = ARRAY_TYPES[e.componentType], d = COMPONENTS[e.type], f = BYTES[e.componentType];
  return {
    ArrayType: u,
    length: e.count * d,
    byteLength: e.count * d * f
  };
}
function resolveUrl(e, l) {
  if (typeof e != "string" || e === "")
    return "";
  try {
    if (e.startsWith("data:") || e.startsWith("blob:"))
      return e;
    let u = new URL(l);
    return !u.pathname.includes(".") && !u.pathname.endsWith("/") && (u.pathname += "/"), e.startsWith("http:") || e.startsWith("https:") || e.startsWith("//") || e.startsWith("/"), new URL(e, u).href;
  } catch (e2) {
    return vtkErrorMacro$1("Error resolving URL:", e2), "";
  }
}
async function loadImage(e) {
  if (e.bufferView) {
    let l = new Blob([e.bufferView.data], { type: e.mimeType });
    return await createImageBitmap(l, {
      colorSpaceConversion: "none",
      imageOrientation: "flipY"
    });
  }
  return e.uri ? (vtkWarningMacro$4("Falling back to image uri", e.uri), new Promise((l, u) => {
    let d = new Image();
    d.crossOrigin = "Anonymous", d.onload = () => {
      l(d);
    }, d.onerror = u, d.src = e.uri;
  })) : null;
}
function createVTKTextureFromGLTFTexture(e, l, u) {
  let d = vtkTexture$1.newInstance();
  if (l)
    if ("wrapS" in l && "wrapT" in l || "minFilter" in l && "magFilter" in l) {
      l.wrapS === GL_SAMPLER.CLAMP_TO_EDGE || l.wrapT === GL_SAMPLER.CLAMP_TO_EDGE ? (d.setRepeat(false), d.setEdgeClamp(true)) : l.wrapS === GL_SAMPLER.REPEAT || l.wrapT === GL_SAMPLER.REPEAT ? (d.setRepeat(true), d.setEdgeClamp(false)) : vtkWarningMacro$4("Mirrored texture wrapping is not supported!");
      let e2 = [
        GL_SAMPLER.LINEAR,
        GL_SAMPLER.LINEAR_MIPMAP_NEAREST,
        GL_SAMPLER.NEAREST_MIPMAP_LINEAR,
        GL_SAMPLER.LINEAR_MIPMAP_LINEAR
      ];
      (e2.includes(l.minFilter) || e2.includes(l.magFilter)) && d.setInterpolate(true);
    } else
      d.setMipLevel(8), d.setInterpolate(true), d.setEdgeClamp(true);
  return d.setImageBitmap(e), d;
}
var { vtkDebugMacro: vtkDebugMacro$3, vtkWarningMacro: vtkWarningMacro$3 } = macro, GLTFParser = class {
  constructor(e) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { json: u, baseUri: d = "" } = e;
    this.glTF = e, this.options = l, this.baseUri = d, this.json = u, this.extensions = u.extensions || {}, this.extensionsUsed = u.extensionsUsed || [];
  }
  async parse() {
    let e = this.json.buffers || [];
    this.buffers = Array(e.length).fill(null);
    let l = this.json.images || [];
    return this.images = Array(l.length).fill({}), await this.loadBuffers(), await this.loadImages(), this.resolveTree(), this.glTF.json;
  }
  resolveTree() {
    this.json.scenes = this.json.scenes?.map((e, l) => this.resolveScene(e, l)), this.json.cameras = this.json.cameras?.map((e, l) => this.resolveCamera(e, l)), this.json.bufferViews = this.json.bufferViews?.map((e, l) => this.resolveBufferView(e, l)), this.json.images = this.json.images?.map((e, l) => this.resolveImage(e, l)), this.json.samplers = this.json.samplers?.map((e, l) => this.resolveSampler(e, l)), this.json.textures = this.json.textures?.map((e, l) => this.resolveTexture(e, l)), this.json.accessors = this.json.accessors?.map((e, l) => this.resolveAccessor(e, l)), this.json.materials = this.json.materials?.map((e, l) => this.resolveMaterial(e, l)), this.json.meshes = this.json.meshes?.map((e, l) => this.resolveMesh(e, l)), this.json.nodes = this.json.nodes?.map((e, l) => this.resolveNode(e, l)), this.json.skins = this.json.skins?.map((e, l) => this.resolveSkin(e, l)), this.json.animations = this.json.animations?.map((e, l) => this.resolveAnimation(e, l));
  }
  get(e, l) {
    if (typeof l == "object")
      return l;
    let u = this.json[e] && this.json[e][l];
    return u || vtkWarningMacro$3(`glTF file error: Could not find ${e}[${l}]`), u;
  }
  resolveScene(e, l) {
    return e.id = e.id || `scene-${l}`, e.nodes = (e.nodes || []).map((e2) => this.get("nodes", e2)), e;
  }
  resolveNode(e, l) {
    return e.id = e.id || `node-${l}`, e.children &&= e.children.map((e2) => this.get("nodes", e2)), e.mesh === void 0 ? e.meshes !== void 0 && e.meshes.length && (e.mesh = e.meshes.reduce((e2, l2) => {
      let u = this.get("meshes", l2);
      return e2.id = u.id, e2.primitives = e2.primitives.concat(u.primitives), e2;
    }, { primitives: [] })) : e.mesh = this.get("meshes", e.mesh), e.camera !== void 0 && (e.camera = this.get("cameras", e.camera)), e.skin !== void 0 && (e.skin = this.get("skins", e.skin)), e.extensions?.KHR_lights_punctual && (e.extensions.KHR_lights_punctual.light = this.extensions?.KHR_lights_punctual.lights[e.extensions.KHR_lights_punctual.light]), e;
  }
  resolveSkin(e, l) {
    return e.id = e.id || `skin-${l}`, e.inverseBindMatrices = this.get("accessors", e.inverseBindMatrices), e;
  }
  resolveMesh(e, l) {
    return e.id = e.id || `mesh-${l}`, e.primitives &&= e.primitives.map((e2, l2) => {
      let u = e2.attributes;
      for (let d in e2.name = `primitive-${l2}`, e2.attributes = {}, u) {
        let l3 = SEMANTIC_ATTRIBUTE_MAP[d];
        e2.attributes[l3] = this.get("accessors", u[d]);
      }
      if (e2.indices !== void 0 && (e2.indices = this.get("accessors", e2.indices)), e2.material !== void 0 && (e2.material = this.get("materials", e2.material)), e2.mode === void 0 && (e2.mode = MODES.GL_TRIANGLES), e2.extensions?.KHR_draco_mesh_compression) {
        vtkDebugMacro$3("Using Draco mesh compression");
        let l3 = this.get("bufferViews", e2.extensions.KHR_draco_mesh_compression.bufferView);
        e2.extensions.KHR_draco_mesh_compression.bufferView = l3.data;
      }
      return e2;
    }), e;
  }
  resolveMaterial(e, l) {
    if (e.id = e.id || `material-${l}`, e.alphaMode === void 0 && (e.alphaMode = ALPHA_MODE.OPAQUE), e.doubleSided === void 0 && (e.doubleSided = false), e.alphaCutoff === void 0 && (e.alphaCutoff = 0.5), e.normalTexture && (e.normalTexture = { ...e.normalTexture }, e.normalTexture.texture = this.get("textures", e.normalTexture.index)), e.occlusionTexture && (e.occlusionTexture = { ...e.occlusionTexture }, e.occlusionTexture.texture = this.get("textures", e.occlusionTexture.index)), e.emissiveTexture && (e.emissiveTexture = { ...e.emissiveTexture }, e.emissiveTexture.texture = this.get("textures", e.emissiveTexture.index)), e.emissiveFactor ? e.emissiveFactor = e.emissiveFactor[0] : e.emissiveFactor = e.emissiveTexture ? 1 : 0, e.pbrMetallicRoughness) {
      e.pbrMetallicRoughness = { ...e.pbrMetallicRoughness };
      let l2 = e.pbrMetallicRoughness;
      l2.baseColorTexture && (l2.baseColorTexture = { ...l2.baseColorTexture }, l2.baseColorTexture.texture = this.get("textures", l2.baseColorTexture.index)), l2.metallicRoughnessTexture && (l2.metallicRoughnessTexture = { ...l2.metallicRoughnessTexture }, l2.metallicRoughnessTexture.texture = this.get("textures", l2.metallicRoughnessTexture.index));
    } else
      e.pbrMetallicRoughness = {
        baseColorFactor: [
          1,
          1,
          1,
          1
        ],
        metallicFactor: 1,
        roughnessFactor: 1
      };
    return e;
  }
  getValueFromInterleavedBuffer(e, l, u, d, f) {
    let p = new Uint8Array(f * d);
    for (let m = 0; m < f; m++) {
      let f2 = l + m * u;
      p.set(new Uint8Array(e.arrayBuffer.slice(f2, f2 + d)), m * d);
    }
    return p.buffer;
  }
  resolveAccessor(e, l) {
    if (e.id = e.id || `accessor-${l}`, e.bufferView !== void 0 && (e.bufferView = this.get("bufferViews", e.bufferView)), e.bytesPerComponent = BYTES[e.componentType], e.components = COMPONENTS[e.type], e.bytesPerElement = e.bytesPerComponent * e.components, e.bufferView) {
      let l2 = e.bufferView.buffer, { ArrayType: u } = getAccessorArrayTypeAndLength(e, e.bufferView), d = (e.bufferView.byteOffset || 0) + l2.byteOffset + (e.byteOffset || 0), f;
      f = e.bufferView.byteStride ? e.bufferView.byteStride === e.bytesPerElement ? new u(l2.arrayBuffer, d, e.count * e.components) : new u(this.getValueFromInterleavedBuffer(l2, d, e.bufferView.byteStride, e.bytesPerElement, e.count)) : new u(l2.arrayBuffer, d, e.count * e.components), e.value = f;
    }
    return e;
  }
  resolveTexture(e, l) {
    return e.id = e.id || `texture-${l}`, e.sampler = "sampler" in e ? this.get("samplers", e.sampler) : DEFAULT_SAMPLER, e.source = this.get("images", e.source), e.extensions !== void 0 && Object.keys(e.extensions).forEach((l2) => {
      let u = e.extensions[l2];
      switch (l2) {
        case "KHR_texture_basisu":
        case "EXT_texture_webp":
        case "EXT_texture_avif":
          e.source = this.get("images", u.source);
          break;
        default:
          vtkWarningMacro$3(`Unhandled extension: ${l2}`);
      }
    }), e;
  }
  resolveSampler(e, l) {
    for (let u in e.id = e.id || `sampler-${l}`, Object.hasOwn(e, "wrapS") || (e.wrapS = GL_SAMPLER.REPEAT), Object.hasOwn(e, "wrapT") || (e.wrapT = GL_SAMPLER.REPEAT), Object.hasOwn(e, "minFilter") || (e.minFilter = GL_SAMPLER.LINEAR_MIPMAP_LINEAR), Object.hasOwn(e, "magFilter") || (e.magFilter = GL_SAMPLER.NEAREST), e.parameters = {}, e) {
      let l2 = getGLEnumFromSamplerParameter(u);
      l2 !== void 0 && (e.parameters[l2] = e[u]);
    }
    return e;
  }
  resolveImage(e, l) {
    return e.id = e.id || `image-${l}`, e.bufferView !== void 0 && (e.bufferView = this.get("bufferViews", e.bufferView)), e;
  }
  resolveBufferView(e, l) {
    e.id = e.id || `bufferView-${l}`;
    let u = e.buffer;
    e.buffer = this.buffers[u];
    let d = this.buffers[u].arrayBuffer, f = this.buffers[u].byteOffset || 0;
    return "byteOffset" in e && (f += e.byteOffset), e.data = new Uint8Array(d, f, e.byteLength), e;
  }
  resolveCamera(e, l) {
    return e.id = e.id || `camera-${l}`, e;
  }
  resolveAnimation(e, l) {
    return e.id = e.id || `animation-${l}`, e.samplers.map((e2) => (e2.input = this.get("accessors", e2.input).value, e2.output = this.get("accessors", e2.output).value, e2)), e;
  }
  loadBuffers() {
    let e = this.json.buffers.map((e2, l) => this.loadBuffer(e2, l).then(() => {
      delete e2.uri;
    }));
    return Promise.all(e);
  }
  async loadBuffer(e, l) {
    let u = e;
    if (e.uri) {
      vtkDebugMacro$3("Loading uri", e.uri);
      let l2 = resolveUrl(e.uri, this.options.baseUri);
      u = await (await fetch(l2)).arrayBuffer();
    } else
      this.glTF.glbBuffers && (u = this.glTF.glbBuffers[l]);
    this.buffers[l] = {
      arrayBuffer: u,
      byteOffset: 0,
      byteLength: u.byteLength
    };
  }
  loadImages() {
    let e = this.json.images || [], l = [];
    return new Promise((u, d) => {
      for (let u2 = 0; u2 < e.length; ++u2)
        l.push(Promise.resolve(this.loadImage(e[u2], u2).then(() => {
          vtkDebugMacro$3("Texture loaded ", e[u2]);
        })));
      Promise.all(l).then(() => u(this.images));
    });
  }
  async loadImage(e, l) {
    let u, d;
    if (e.uri) {
      vtkDebugMacro$3("Loading texture", e.uri);
      let l2 = resolveUrl(e.uri, this.options.baseUri);
      u = await (await fetch(l2)).arrayBuffer(), e.uri = l2, e.bufferView = { data: u };
    } else if (e.bufferView) {
      let l2 = this.get("bufferViews", e.bufferView);
      d = this.get("buffers", l2.buffer), this.glTF.glbBuffers && (d = this.glTF.glbBuffers[l2.buffer], u = d.slice(l2.byteOffset, l2.byteOffset + l2.byteLength)), e.bufferView = { data: u };
    }
  }
}, { vtkWarningMacro: vtkWarningMacro$2 } = macro;
function handleKHRMaterialsUnlit(e, l) {
  l.setLighting(true);
}
function handleKHRMaterialsIor(e, l) {
  l.setBaseIOR(e.ior);
}
function handleKHRMaterialsSpecular(e, l) {
  l.setSpecular(e.specularFactor), l.setSpecularColor(e.specularColorFactor);
}
function handleKHRLightsPunctual(e, l, u) {
  let { light: d } = e, { color: f, intensity: p, range: h, spot: g, type: _ } = d, v = vtkLight$1.newInstance({
    color: f || [
      1,
      1,
      1
    ],
    intensity: p || 1
  });
  switch (v.setTransformMatrix(l), h > 0 && v.setAttenuationValues(1, 0, 1 / (h * h * MIN_LIGHT_ATTENUATION)), _) {
    case "directional":
      v.setPositional(false);
      break;
    case "point":
      v.setPositional(true), v.setConeAngle(90);
      break;
    case "spot":
      v.setPositional(true), v.setConeAngle(radiansFromDegrees(g.outerConeAngle));
      break;
    default:
      vtkWarningMacro$2(`Unsupported light type: ${_}`);
  }
  u.lights.set(d.name, v);
}
function handleKHRDracoMeshCompression(e) {
  let l = vtkDracoReader$1.newInstance();
  return l.parse(e.bufferView), l.getOutputData();
}
function handleKHRMaterialsVariants(e, l) {
  l.variants = e.variants.map((e2) => e2.name);
}
var { vtkWarningMacro: vtkWarningMacro$1, vtkDebugMacro: vtkDebugMacro$2 } = macro;
async function parseGLTF(e, l) {
  return await new GLTFParser(e, l).parse();
}
async function createPolyDataFromGLTFMesh(l) {
  if (!l || !l.attributes)
    return vtkWarningMacro$1("Primitive has no position data, skipping"), null;
  if (l.extensions?.KHR_draco_mesh_compression)
    return handleKHRDracoMeshCompression(l.extensions.KHR_draco_mesh_compression);
  let u = vtkPolyData$1.newInstance(), d = vtkCellArray$1.newInstance(), f = u.getPointData();
  if (Object.entries(l.attributes).forEach(async (e) => {
    let [d2, p] = e;
    switch (d2) {
      case SEMANTIC_ATTRIBUTE_MAP.POSITION: {
        let e2 = l.attributes.position.value;
        u.getPoints().setData(e2, l.attributes.position.component);
        break;
      }
      case SEMANTIC_ATTRIBUTE_MAP.NORMAL: {
        let e2 = l.attributes.normal.value;
        f.setNormals(vtkDataArray$1.newInstance({
          name: "Normals",
          values: e2,
          numberOfComponents: l.attributes.normal.components
        }));
        break;
      }
      case SEMANTIC_ATTRIBUTE_MAP.COLOR_0: {
        let e2 = l.attributes.color.value;
        f.setScalars(vtkDataArray$1.newInstance({
          name: "Scalars",
          values: e2,
          numberOfComponents: l.attributes.color.components
        }));
        break;
      }
      case SEMANTIC_ATTRIBUTE_MAP.TEXCOORD_0: {
        let e2 = l.attributes.texcoord0.value, u2 = vtkDataArray$1.newInstance({
          name: "TEXCOORD_0",
          values: e2,
          numberOfComponents: l.attributes.texcoord0.components
        });
        f.addArray(u2), f.setActiveTCoords(u2.getName());
        break;
      }
      case SEMANTIC_ATTRIBUTE_MAP.TEXCOORD_1: {
        let e2 = l.attributes.texcoord1.value, u2 = vtkDataArray$1.newInstance({
          name: "TEXCOORD_1",
          values: e2,
          numberOfComponents: l.attributes.texcoord1.components
        });
        f.addArray(u2);
        break;
      }
      case SEMANTIC_ATTRIBUTE_MAP.TANGENT: {
        let e2 = l.attributes.tangent.value, u2 = vtkDataArray$1.newInstance({
          name: "Tangents",
          values: e2,
          numberOfComponents: l.attributes.tangent.components
        });
        f.addArray(u2);
        break;
      }
      default:
        vtkWarningMacro$1(`Unhandled attribute: ${d2}`);
    }
  }), l.indices != null) {
    let e = l.indices.value, u2 = e.length - 2;
    switch (l.mode) {
      case MODES.GL_LINE_STRIP:
      case MODES.GL_TRIANGLE_STRIP:
      case MODES.GL_LINE_LOOP:
        vtkWarningMacro$1("GL_LINE_LOOP not implemented");
        break;
      default:
        d.allocate(4 * e.length / 3);
        for (let l2 = 0; l2 < u2; l2 += 3) {
          let u3 = e.slice(l2, l2 + 3);
          d.insertNextCell(u3);
        }
    }
  }
  switch (l.mode) {
    case MODES.GL_TRIANGLES:
    case MODES.GL_TRIANGLE_FAN:
      u.setPolys(d);
      break;
    case MODES.GL_LINES:
    case MODES.GL_LINE_STRIP:
    case MODES.GL_LINE_LOOP:
      u.setLines(d);
      break;
    case MODES.GL_POINTS:
      u.setVerts(d);
      break;
    case MODES.GL_TRIANGLE_STRIP:
      u.setStrips(d);
      break;
    default:
      d.delete(), vtkWarningMacro$1("Invalid primitive draw mode. Ignoring connectivity.");
  }
  return u;
}
async function createPropertyFromGLTFMaterial(e, l, u) {
  let d = 1, f = 1, p = l.emissiveFactor, m = u.getProperty(), h = l.pbrMetallicRoughness;
  if (h != null) {
    !h?.metallicFactor || h?.metallicFactor <= 0 || h?.metallicFactor >= 1 ? vtkDebugMacro$2("Invalid material.pbrMetallicRoughness.metallicFactor value. Using default value instead.") : d = h.metallicFactor, !h?.roughnessFactor || h?.roughnessFactor <= 0 || h?.roughnessFactor >= 1 ? vtkDebugMacro$2("Invalid material.pbrMetallicRoughness.roughnessFactor value. Using default value instead.") : f = h.roughnessFactor;
    let e2 = h.baseColorFactor;
    if (e2 != null && (m.setDiffuseColor(e2[0], e2[1], e2[2]), m.setOpacity(e2[3])), m.setMetallic(d), m.setRoughness(f), m.setEmission(p), h.baseColorTexture) {
      h.baseColorTexture.extensions;
      let e3 = h.baseColorTexture.texture;
      e3.extensions != null && Object.keys(e3.extensions).forEach((e4) => {
        switch (e4) {
          default:
            vtkWarningMacro$1(`Unhandled extension: ${e4}`);
        }
      });
      let l2 = e3.sampler, u2 = createVTKTextureFromGLTFTexture(await loadImage(e3.source), l2);
      m.setDiffuseTexture(u2);
    }
    if (h.metallicRoughnessTexture) {
      h.metallicRoughnessTexture.extensions;
      let e3 = h.metallicRoughnessTexture.texture, l2 = e3.sampler, u2 = createVTKTextureFromGLTFTexture(await loadImage(e3.source), l2);
      m.setRMTexture(u2);
    }
    if (l.occlusionTexture) {
      l.occlusionTexture.extensions;
      let e3 = l.occlusionTexture.texture, u2 = e3.sampler, d2 = createVTKTextureFromGLTFTexture(await loadImage(e3.source), u2);
      m.setAmbientOcclusionTexture(d2);
    }
    if (l.emissiveTexture) {
      l.emissiveTexture.extensions;
      let e3 = l.emissiveTexture.texture, d2 = e3.sampler, f2 = createVTKTextureFromGLTFTexture(await loadImage(e3.source), d2);
      m.setEmissionTexture(f2), l.emissiveTexture.texCoord != null && u.getMapper().getInputData().getPointData().setActiveTCoords(`TEXCOORD_${l.emissiveTexture.texCoord}`);
    }
    if (l.normalTexture) {
      l.normalTexture.extensions;
      let e3 = l.normalTexture.texture, u2 = e3.sampler, d2 = createVTKTextureFromGLTFTexture(await loadImage(e3.source), u2);
      m.setNormalTexture(d2), l.normalTexture.scale != null && m.setNormalStrength(l.normalTexture.scale);
    }
  }
  l.extensions != null && Object.keys(l.extensions).forEach((e2) => {
    let u2 = l.extensions[e2];
    switch (e2) {
      case "KHR_materials_unlit":
        handleKHRMaterialsUnlit(u2, m);
        break;
      case "KHR_materials_ior":
        handleKHRMaterialsIor(u2, m);
        break;
      case "KHR_materials_specular":
        handleKHRMaterialsSpecular(u2, m);
        break;
      default:
        vtkWarningMacro$1(`Unhandled extension: ${e2}`);
    }
  }), l.alphaMode !== ALPHA_MODE.OPAQUE && u.setForceTranslucent(true), m.setBackfaceCulling(!l.doubleSided);
}
function handlePrimitiveExtensions(e, l, u) {
  Object.keys(l).forEach((d) => {
    let f = l[d];
    switch (d) {
      case "KHR_materials_variants":
        u.variantMappings.set(e, f.mappings);
        break;
      case "KHR_draco_mesh_compression":
        break;
      default:
        vtkWarningMacro$1(`Unhandled extension: ${d}`);
    }
  });
}
async function createActorFromGTLFNode(e) {
  let l = vtkActor$1.newInstance(), u = vtkMapper$1.newInstance();
  u.setColorModeToDirectScalars(), u.setInterpolateScalarsBeforeMapping(true), l.setMapper(u), l.setUserMatrix(e);
  let d = vtkPolyData$1.newInstance();
  return u.setInputData(d), l;
}
async function createActorFromGTLFPrimitive(e, l, u) {
  let d = vtkActor$1.newInstance(), f = vtkMapper$1.newInstance();
  f.setColorModeToDirectScalars(), f.setInterpolateScalarsBeforeMapping(true), d.setMapper(f), d.setUserMatrix(u);
  let p = await createPolyDataFromGLTFMesh(l);
  return f.setInputData(p), l.material != null && await createPropertyFromGLTFMaterial(e, l.material, d), l.extensions != null && handlePrimitiveExtensions(`${l.name}`, l.extensions, e), d;
}
function createGLTFAnimation(e) {
  return vtkDebugMacro$2("Creating animation:", e), {
    name: e.name,
    channels: e.channels,
    samplers: e.samplers,
    getChannelByTargetNode(e2) {
      return this.channels.filter((l) => l.target.node === e2);
    }
  };
}
function getTransformationMatrix(e) {
  let l = e.translation ?? create(), u = e.rotation ?? create$1(), d = e.scale ?? fromValues(1, 1, 1);
  return e.matrix == null ? fromRotationTranslationScale(create$2(), u, l, d) : clone(e.matrix);
}
async function processNode(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : create$2();
  e.transform = getTransformationMatrix(e);
  let f = multiply(create$2(), d, e.transform);
  if (e.mesh != null) {
    let d2 = await createActorFromGTLFNode(f);
    u && d2.setParentProp(u), l.actors.set(`${e.id}`, d2), await Promise.all(e.mesh.primitives.map(async (u2, p) => {
      let m = await createActorFromGTLFPrimitive(l, u2, f);
      m.setParentProp(d2), l.actors.set(`${e.id}_${u2.name}`, m);
    }));
  }
  e.extensions?.KHR_lights_punctual && handleKHRLightsPunctual(e.extensions.KHR_lights_punctual, e.transform, l), e.children && Array.isArray(e.children) && e.children.length > 0 && await Promise.all(e.children.map(async (u2) => {
    await processNode(u2, l, l.actors.get(e.id), f);
  }));
}
async function createVTKObjects(e) {
  e.animations = e.glTFTree.animations?.map(createGLTFAnimation), Object.keys(e.glTFTree?.extensions || []).forEach((l2) => {
    let u = e.glTFTree.extensions[l2];
    switch (l2) {
      case "KHR_materials_variants":
        handleKHRMaterialsVariants(u, e);
        break;
      case "KHR_draco_mesh_compression":
        break;
      default:
        vtkWarningMacro$1(`Unhandled extension: ${l2}`);
    }
  });
  let l = e.sceneId ?? e.glTFTree.scene;
  e.glTFTree.scenes?.length && e.glTFTree.scenes[l]?.nodes ? await Promise.all(e.glTFTree.scenes[l].nodes.map(async (l2) => {
    l2 ? await processNode(l2, e) : vtkWarningMacro$1("Node not found in glTF.nodes");
  })) : vtkWarningMacro$1("No valid scenes found in the glTF data");
}
function GLTFCameraToVTKCamera(e) {
  let l = vtkCamera$1.newInstance();
  if (e.type === "perspective") {
    let { yfov: d, znear: f, zfar: p } = e.perspective;
    l.setClippingRange(f, p), l.setParallelProjection(false), l.setViewAngle(degreesFromRadians(d));
  } else if (e.type === "orthographic") {
    let { ymag: u, znear: d, zfar: f } = e.orthographic;
    l.setClippingRange(d, f), l.setParallelProjection(true), l.setParallelScale(u);
  } else
    throw Error("Unsupported camera type");
  return l;
}
function applyTransformToCamera(e, l) {
  if (!e || !l)
    return;
  let u = [
    0,
    0,
    0
  ], d = [
    0,
    1,
    0
  ], f = [
    0,
    0,
    -1
  ], p = vtkTransform$1.newInstance();
  p.setMatrix(l), p.transformPoint(u, u), p.transformPoints(d, d), p.transformPoints(f, f), f[0] += u[0], f[1] += u[1], f[2] += u[2], e.setPosition(u), e.setFocalPoint(f), e.setViewUp(d);
}
function getChunkInfo(e, l) {
  let u = new Uint32Array(l, e, 2);
  return {
    start: e + 8,
    length: u[0],
    type: u[1]
  };
}
function getAllChunkInfos(e) {
  let l = Math.floor((e.byteLength - 12) / 8), u = Array(l), d = 12, f = 0;
  for (; d < e.byteLength; ) {
    let l2 = getChunkInfo(d, e);
    u[f++] = l2, d += l2.length + 8;
  }
  return u.slice(0, f);
}
function getJsonFromChunk(e, l) {
  let u = new Uint8Array(l, 20, e.length), d = new TextDecoder("utf-8").decode(u);
  return JSON.parse(d);
}
function getBufferFromChunk(e, l) {
  return l.slice(e.start, e.start + e.length);
}
function parseGLB(e) {
  if (e.byteLength < 12)
    throw Error("Invalid GLB: File too small");
  let l = new DataView(e, 0, 12), u = new Uint8Array(e, 0, 4), d = {
    magic: BinaryHelper.arrayBufferToString(u),
    version: l.getUint32(4, true),
    length: l.getUint32(8, true)
  };
  if (d.magic !== "glTF")
    throw Error("Unsupported glTF-Binary header.");
  if (d.version < 2)
    throw Error("Unsupported legacy binary file detected.");
  if (d.length > e.byteLength)
    throw Error("Invalid GLB: Declared length exceeds file size");
  let f = getAllChunkInfos(e), p = null, m = [];
  for (let l2 = 0; l2 < f.length; l2++) {
    let u2 = f[l2];
    u2.type === BINARY_CHUNK_TYPES.JSON && !p ? p = getJsonFromChunk(u2, e) : u2.type === BINARY_CHUNK_TYPES.BIN && m.push(getBufferFromChunk(u2, e));
  }
  if (!p)
    throw Error("glTF-Binary: JSON content not found.");
  return {
    json: p,
    buffers: m
  };
}
var { vtkDebugMacro: vtkDebugMacro$1, vtkWarningMacro } = macro;
function createAnimationChannel(e, l) {
  let d = e.target.path, p = e.target.node;
  function m(e2) {
    let l2, m2, h2;
    switch (d) {
      case "translation":
        p.setPosition(e2[0], e2[1], e2[2]);
        break;
      case "rotation":
        h2 = normalize(create$1(), e2), l2 = new Float64Array(3), m2 = getAxisAngle(l2, h2), p.rotateWXYZ(degreesFromRadians(m2), l2[0], l2[1], l2[2]);
        break;
      case "scale":
        p.setScale(e2[0], e2[1], e2[2]);
        break;
      default:
        vtkWarningMacro(`Unsupported animation path: ${d}`);
    }
  }
  function h(u) {
    m(l[e.sampler].evaluate(u, d));
  }
  return {
    ...e,
    animate: h
  };
}
function createAnimationSampler(e) {
  let l = 0;
  function u(u2) {
    let d2 = l;
    for (; d2 < e.input.length - 1 && e.input[d2] <= u2; )
      d2++;
    let f = Math.max(0, d2 - 1);
    return l = f, [
      e.input[f],
      e.input[d2],
      f,
      d2
    ];
  }
  function d(l2, u2) {
    let d2 = u2 * 3, f = [
      ,
      ,
      ,
    ];
    for (let l3 = 0; l3 < 3; ++l3)
      f[l3] = e.output[d2 + l3];
    return f;
  }
  function p(l2, u2, d2, p2, m2, h2) {
    let g = (h2 - u2) / (d2 - u2), _ = p2 * 4, v = m2 * 4, y = [
      ,
      ,
      ,
      ,
    ], x = [
      ,
      ,
      ,
      ,
    ];
    for (let l3 = 0; l3 < 4; ++l3)
      y[l3] = e.output[_ + l3], x[l3] = e.output[v + l3];
    switch (l2) {
      case "translation":
      case "scale":
        return lerp(create(), y, x, g);
      case "rotation":
        return slerp(create$1(), y, x, g);
      default:
        return vtkWarningMacro(`Unsupported animation path: ${l2}`), null;
    }
  }
  function m(l2, u2, d2, f, p2, m2) {
    let h2 = d2 - u2, g = (m2 - u2) / h2, _ = g * g, v = _ * g, y = e.output[f * 3 + 1], b = h2 * e.output[f * 3 + 2], x = e.output[p2 * 3 + 1], S = h2 * e.output[p2 * 3];
    if (Array.isArray(y))
      return y.map((e2, l3) => {
        let u3 = 2 * v - 3 * _ + 1, d3 = v - 2 * _ + g, f2 = -2 * v + 3 * _, p3 = v - _;
        return u3 * e2 + d3 * b[l3] + f2 * x[l3] + p3 * S[l3];
      });
    let C = 2 * v - 3 * _ + 1, w = v - 2 * _ + g, T = -2 * v + 3 * _, E = v - _;
    return C * y + w * b + T * x + E * S;
  }
  function h(l2, f) {
    let [h2, g, _, v] = u(l2), y;
    switch (e.interpolation) {
      case "STEP":
        y = d(f, _);
        break;
      case "LINEAR":
        y = p(f, h2, g, _, v, l2);
        break;
      case "CUBICSPLINE":
        y = m(f, h2, g, _, v, l2);
        break;
      default:
        vtkWarningMacro(`Unknown interpolation method: ${e.interpolation}`);
    }
    return y;
  }
  return {
    ...e,
    evaluate: h
  };
}
function createAnimation(e, l) {
  e.samplers = e.samplers.map((e2) => createAnimationSampler(e2)), e.channels = e.channels.map((u2) => (u2.target.node = l.get(`node-${u2.target.node}`), createAnimationChannel(u2, e.samplers)));
  function u(l2) {
    e.channels.forEach((e2) => e2.animate(l2));
  }
  return {
    ...e,
    update: u
  };
}
function createAnimationMixer(e, l) {
  let u = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
  function f(l2) {
    let d2 = createAnimation(l2, e);
    u.set(l2.id, d2), vtkDebugMacro$1(`Animation "${l2.id}" added to mixer`);
  }
  function p(e2) {
    let l2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!u.has(e2)) {
      vtkWarningMacro(`Animation "${e2}" not found in mixer`);
      return;
    }
    d.set(e2, {
      animation: u.get(e2),
      weight: l2,
      time: 0
    }), vtkDebugMacro$1(`Playing animation "${e2}" with weight ${l2}`);
  }
  function m(e2) {
    d.delete(e2) ? vtkWarningMacro(`Stopped animation "${e2}"`) : vtkWarningMacro(`Animation "${e2}" was not playing`);
  }
  function h() {
    d.clear(), vtkWarningMacro("Stopped all animations");
  }
  function g(e2) {
    let l2 = Array.from(d.values()).reduce((e3, l3) => {
      let { weight: u2 } = l3;
      return e3 + u2;
    }, 0);
    d.forEach((u2, f2) => {
      let { animation: p2, weight: m2, time: h2 } = u2, g2 = l2 > 0 ? m2 / l2 : 0, _ = h2 + e2;
      d.set(f2, {
        animation: p2,
        weight: m2,
        time: _
      }), vtkDebugMacro$1(`Updating animation "${f2}" at time ${_.toFixed(3)} with normalized weight ${g2.toFixed(3)}`), p2.update(_, g2);
    });
  }
  return {
    addAnimation: f,
    play: p,
    stop: m,
    stopAll: h,
    update: g
  };
}
var { vtkDebugMacro, vtkErrorMacro } = macro;
function vtkGLTFImporter(e, l) {
  l.classHierarchy.push("vtkGLTFImporter"), l.dataAccessHelper ||= DataAccessHelper.get("http");
  function u(u2) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { compression: f, progressCallback: p } = l;
    return d.binary ? l.dataAccessHelper.fetchBinary(u2, {
      compression: f,
      progressCallback: p
    }) : l.dataAccessHelper.fetchText(e, u2, {
      compression: f,
      progressCallback: p
    });
  }
  e.setUrl = function(u2) {
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { binary: true };
    l.url = u2;
    let f = u2.split("/");
    return f.pop(), l.baseURL = f.join("/"), l.compression = d.compression, l.sceneId = d.sceneId ? d.sceneId : 0, e.loadData({
      progressCallback: d.progressCallback,
      binary: !!d.binary
    });
  }, e.loadData = function() {
    let d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = u(l.url, d);
    return f.then(e.parse), f;
  }, e.parse = (l2) => {
    typeof l2 == "string" ? e.parseAsText(l2) : e.parseAsBinary(l2);
  }, e.parseAsBinary = async (u2) => {
    if (!u2)
      return;
    if (u2 !== l.parseData)
      e.modified();
    else
      return;
    let d = {}, f = { baseUri: l.baseURL };
    if (BinaryHelper.arrayBufferToString(new Uint8Array(u2, 0, 4)) === "glTF") {
      let { json: e2, buffers: l2 } = parseGLB(u2);
      vtkDebugMacro("Loaded GLB", e2, l2), d.glbBuffers = l2, d.json = e2;
    } else
      d.json = JSON.parse(BinaryHelper.arrayBufferToString(u2));
    if (d.json.asset === void 0 || d.json.asset.version[0] < 2) {
      vtkErrorMacro("Unsupported asset. glTF versions >=2.0 are supported.");
      return;
    }
    l.glTFTree = await parseGLTF(d, f), l.actors = /* @__PURE__ */ new Map(), l.cameras = /* @__PURE__ */ new Map(), l.lights = /* @__PURE__ */ new Map(), l.animations = [], l.variants = [], l.variantMappings = /* @__PURE__ */ new Map(), await createVTKObjects(l), l.scenes = l.glTFTree.scenes, e.invokeReady();
  }, e.parseAsText = (u2) => {
    if (u2) {
      if (u2 !== l.parseData)
        e.modified();
      else
        return;
      l.parseData = u2;
    }
  }, e.requestData = (u2, d) => {
    e.parse(l.parseData);
  }, e.setDracoDecoder = async (e2) => {
    await vtkDracoReader$1.setDracoDecoder(e2);
  }, e.importActors = () => {
    l.actors.forEach((e2) => l.renderer.addActor(e2));
  }, e.importCameras = () => {
    l.glTFTree.cameras?.forEach((e2) => {
      let u2 = GLTFCameraToVTKCamera(e2);
      l.cameras.set(e2.id, u2);
    }), l.scenes.forEach((e2) => {
      e2.nodes.forEach((e3) => {
        let u2 = l.cameras.get(e3.camera?.id);
        u2 && applyTransformToCamera(u2, e3.transform);
      });
    });
  }, e.importAnimations = () => {
    l.glTFTree.animations?.length > 0 && (l.animationMixer = createAnimationMixer(l.actors, l.glTFTree.accessors), l.glTFTree.animations.forEach((e2) => {
      l.animationMixer.addAnimation(e2);
    })), l.animations = l.glTFTree.animations || [];
  }, e.importLights = () => {
    l.lights?.forEach((e2) => {
      vtkDebugMacro("Adding light", e2), l.renderer.addLight(e2);
    });
  }, e.setCamera = (e2) => {
    let u2 = l.cameras.get(e2);
    if (!u2) {
      vtkErrorMacro(`Camera ${e2} not found`);
      return;
    }
    vtkDebugMacro("Setting camera", u2), l.renderer.setActiveCamera(u2);
  }, e.switchToVariant = async (e2) => {
    let u2 = Array.from(l.actors).map(async (u3) => {
      let [d, f] = u3;
      vtkDebugMacro("Switching to variant", e2, "for node", d);
      let p = l.variantMappings.get(d);
      if (p) {
        let u4 = p.find((l2) => l2.variants.includes(e2));
        if (u4) {
          let e3 = l.glTFTree.materials[u4.material];
          await createPropertyFromGLTFMaterial(l, e3, f);
        }
      }
    });
    await Promise.all(u2);
  };
}
var DEFAULT_VALUES$1 = {};
function extend$1(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES$1, u), macro.obj(e, l), macro.get(e, l, [
    "url",
    "baseURL",
    "actors",
    "scenes",
    "cameras",
    "animations",
    "animationMixer",
    "variants",
    "variantMappings"
  ]), macro.set(e, l, ["renderer", "dracoDecoder"]), macro.event(e, l, "ready"), vtkGLTFImporter(e, l), l.compression ||= null, l.progressCallback ||= null;
}
var newInstance$1 = macro.newInstance(extend$1, "vtkGLTFImporter"), vtkGLTFImporter$1 = {
  extend: extend$1,
  newInstance: newInstance$1
};
function vtkSkybox(e, l) {
  l.classHierarchy.push("vtkSkybox"), e.getIsOpaque = () => true, e.hasTranslucentPolygonalGeometry = () => false, e.getSupportsSelection = () => false;
}
var DEFAULT_VALUES = { format: "box" };
function extend(e, l) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(l, DEFAULT_VALUES, u), vtkActor$1.extend(e, l, u), macro.setGet(e, l, ["format"]), vtkSkybox(e, l);
}
var newInstance = macro.newInstance(extend, "vtkSkybox"), vtkSkybox$1 = {
  newInstance,
  extend
};
export {
  newInstance$1 as a,
  vtkSTLWriter$1 as c,
  extend$1 as i,
  vtkLineSource$1 as l,
  newInstance as n,
  vtkGLTFImporter$1 as o,
  vtkSkybox$1 as r,
  vtkWindowedSincPolyDataFilter$1 as s,
  extend as t
};
